<script>
    export default {
        data() {
            return {
                myOptions: {
                    useKeyboardNavigation: false,
                    labels: {
                        buttonSkip: this.$t('lang.main.tour.close'),
                        buttonPrevious: this.$t('lang.main.tour.previous'),
                        buttonNext: this.$t('lang.main.tour.next'),
                        buttonStop: this.$t('lang.main.tour.stop'),
                    },
                    debug: true,
                },
            }
        },
        props: ["name", "steps", "callbacks", "contentClass", "modalClass"],
        computed: {
            contentClasses () {
                return [
                    {'v-step__content': true},
                    {'v-step__content_simple': this.contentClass()},
                ]
            },
        },
    }
</script>

<template>
    <div>
        <v-tour :name="name" :steps="steps" :callbacks="callbacks" :options="myOptions">
<!--            <template v-slot="tour">-->
<!--                <transition name="fade" v-for="(step, index) of tour.steps">-->
<!--                    <v-step-->
<!--                        v-if="tour.currentStep === index"-->
<!--                        :key="index"-->
<!--                        :step="step"-->
<!--                        :previous-step="tour.previousStep"-->
<!--                        :next-step="tour.nextStep"-->
<!--                        :stop="tour.stop"-->
<!--                        :skip="tour.skip"-->
<!--                        :isFirst="tour.isFirst"-->
<!--                        :isLast="tour.isLast"-->
<!--                        :class="modalClass(step)"-->
<!--                        :labels="tour.labels"-->
<!--                    >-->
<!--                        <template>-->
<!--                            <div slot="content">-->
<!--                                <div :class="contentClasses">-->
<!--                                    <div v-if="step.content" v-html="step.content"></div>-->
<!--                                </div>-->
<!--                            </div>-->
<!--                        </template>-->
<!--                    </v-step>-->
<!--                </transition>-->
<!--            </template>-->
        </v-tour>
    </div>
</template>



<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .v-step{
        z-index: 999;
    }
    .v-step:deep(p) {margin: 0 0 10px;}

    .v-step:deep(span.help) {font-size: 12px; line-height: initial;}

    .v-step:deep(hr) {
        margin-top: 10px;
        margin-bottom: 10px;
        border: 0;
        border-top: 1px solid #454d5d;
    }

    .v-step:deep(a) {
        color: #fff;
    }

    .v-step__content_simple{
        font-size: 13px;
        text-align: left;
        line-height: 20px;
    }

    .v-step__content_simple:deep(code) {
        background-color: #454d5d;
        padding: 2px;
        font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
    }

    .v-step__content_simple:deep(ul) {list-style: none; margin: 10px 0; padding: 0 0;}
    .v-step__content_simple:deep(ul) li {margin: 2px 0; padding: 5px 10px; font-size: 13px;}

    .w420{max-width: 420px;}
    .w520{max-width: 520px;}



</style>
